import { useParams } from 'react-router-dom';
import React, { memo, useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { useRoleList } from 'lib/hooks/queries/roles/useRoleList';
import { useNewRoleContext } from 'lib/context/Role/NewRoleContext/NewRoleContext';
import { useEditRoleContext } from 'lib/context/Role/EditRoleContext/EditRoleContext';

import state from 'components/state';
import { currentPractice } from 'components/practice/practiceState';

import AgTablePage from '../shared/AgTablePage/AgTablePage';

import NewRoleModal from './lib/NewRoleModal';
import { defaultColumns } from './lib/helper';
import HeaderActions from './lib/HeaderActions';
import MotionActions from './components/MotionActions';
import { DEFAULT_FILTERS } from './lib/defaultFilters';
import EditRoleModal from './components/EditRole/EditRoleModal';

const Table = ({ isAdmin, forAdmin, setHeaderButtonProps }) => {
  const [rowData, setRowData] = useState({});
  const { setShowNewRoleModal } = useNewRoleContext();
  const { showEditRoleModal, setShowEditRoleModal, formik } = useEditRoleContext();
  const permissions = useRecoilValue(state.permissions);
  const currPractice = useRecoilValue(currentPractice);
  const practiceTimezone = currPractice.timezone;
  const [columns, setColumns] = useState(defaultColumns(permissions, practiceTimezone));

  const { id } = useParams();

  useEffect(() => {
    setColumns(() => defaultColumns(permissions, practiceTimezone, isAdmin, forAdmin));
  }, [permissions]);

  const onCellClicked = (e) => {
    if (e) {
      formik.resetForm();
      setShowEditRoleModal(true);
      setRowData(e);
    }
  };

  return (
    <>
      <AgTablePage
        title="Role"
        onSelectRow={onCellClicked}
        rightHeaderActions={
          <HeaderActions
            forAdmin={forAdmin}
            onAddNewRoleClick={() => {
              setShowNewRoleModal(true);
            }}
          />
        }
        noHeader
        actions={(props) => (
          <MotionActions
            setMotionHeaderButtonProps={setHeaderButtonProps}
            handleOpen={() => {
              setShowNewRoleModal(true);
            }}
            {...props}
          />
        )}
        rowStyle={{ cursor: 'pointer' }}
        defaultColumns={columns}
        defaultFilters={DEFAULT_FILTERS}
        useData={useRoleList}
        queryParams={{ practiceId: id, forAdmin }}
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200 [&_.ag-root-wrapper]:border-0"
        name="role_list"
        autoHeight
      />
      <EditRoleModal
        showModal={!!showEditRoleModal}
        hideModal={() => setShowEditRoleModal(false)}
        roleName={rowData?.name}
        roleType={rowData?.type}
        roleDescription={rowData?.description}
        roleId={rowData?.id}
        isAdmin={isAdmin}
        forAdmin={forAdmin}
      />
      <NewRoleModal forAdmin={forAdmin} />
    </>
  );
};

export default memo(Table);
